import { useRef } from "react";
import { GameRuntimeProvider } from "./ui/context/GameContext";
import PhaserCanvas from "./ui/game-shell/PhaserCanvas";
import HUD from "./ui/game-shell/HUD";

export default function App() {
  const rootRef = useRef<HTMLDivElement>(null);
  const phaserMountRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={rootRef}
      className="relative w-screen h-screen bg-black overflow-hidden"
    >
      <GameRuntimeProvider>
        <HUD rootRef={rootRef} phaserMountRef={phaserMountRef} />
        <PhaserCanvas phaserMountRef={phaserMountRef} />
      </GameRuntimeProvider>
    </div>
  );
}
